import { HttpInterceptorImpl } from './app/components/shared/util/http.interceptor';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { provideToastr } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { BlockUIModule } from 'ng-block-ui';
import { LoadingService } from './app/components/shared/service/loading-service';
import { MsgService } from './app/components/shared/service/msg.service';
import { AuthService } from './app/components/shared/service/auth.service';
import {provideEnvironmentNgxMask} from 'ngx-mask';
import { provideEcharts } from 'ngx-echarts';

const APP_PROVIDERS = [
  provideRouter(routes),
  provideHttpClient(withInterceptorsFromDi()),
  { provide: JWT_OPTIONS, useValue: {} },
  JwtHelperService,
  provideToastr(),
  provideAnimations(),
  provideEnvironmentNgxMask(),
  importProvidersFrom(BlockUIModule.forRoot()),
  LoadingService,
  MsgService,
  AuthService,
  { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorImpl, multi: true },
  provideEcharts(),
];

bootstrapApplication(AppComponent, { providers: APP_PROVIDERS });
